<template>
  <v-container>
    <v-card
      color="grey lighten-4"
      max-height="300px"
      style="overflow-y: scroll"
    >
      <v-container>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
          volutpat risus lacinia, placerat leo ac, iaculis ante. Suspendisse
          efficitur lorem ac tellus tristique venenatis. Interdum et malesuada
          fames ac ante ipsum primis in faucibus. Fusce pellentesque ullamcorper
          mi, at pulvinar sem aliquet sit amet. Sed lobortis lectus sit amet
          nulla cursus, et vulputate elit dapibus. Quisque justo tortor, feugiat
          et volutpat vel, porta auctor lorem. Maecenas id lacus ac ante
          consectetur posuere hendrerit eu est. Curabitur feugiat pellentesque
          magna, malesuada pulvinar lectus accumsan sed. Vivamus quis metus at
          mauris eleifend bibendum in quis libero. Morbi rutrum, urna ac semper
          mattis, lectus massa pellentesque purus, vel congue erat ligula id
          ante.
        </p>
      </v-container>
    </v-card>

    <v-checkbox
      v-model="registrationInfo.UserAgreementPolicy"
      :label="`I agree to user agreement`"
    ></v-checkbox>
  </v-container>
</template>
<script>
export default {
  props: ["registrationInfo"],

  computed: {
    UserAgreementPolicyCheckbox: {
      get() {
        return this.registrationInfo.UserAgreementPolicy;
      },
      set(value) {
        this.registrationInfo.UserAgreementPolicy = value;
      },
    },
  },
};
</script>
